import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { PriceListService } from '../../service/data/pricelist.service';
import { PriceListItem } from '../../model/pricelistitem';
import { ObjectComponentCategory } from '../../../rent/model/object-component-category';
import { CustomProperty } from '../../../rent/model/custom-property';
import { SelectionItem } from '../../../core/component/select/select.component';
import { CustomPropertyService } from '../../../rent/service/data/custom-property.service';
import { ObjectComponentCategoryService } from '../../../rent/service/data/object-component-category.service';
import { AccountPlanService } from '../../../accounting/service/data/account-plan.service';
import { Account } from '../../../accounting/model/account';
import { ObjectComponentType } from '../../../rent/model/object-component-type';
import { ArticleUnit, ArticleUnitKindToString, CustomPropertyDataType } from '../../../rent/model/const/enums';
import { PriceList, PriceListType } from '../../model/pricelist';
import { Currencies } from '../../../core/pipe/currency.pipe';
import { from } from 'rxjs';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import ListViewColumn from '../../../core/model/list-view-column';

@Component({
    selector: 'app-pricelist',
    templateUrl: './pricelist-form.component.html',
    providers: [FormCommandHandlerResolver, DeleteFormCommandHandler, { provide: DataService, useExisting: PriceListService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PriceListFormComponent extends FormComponentBase<PriceList> {
  constructor(
    private _fcf: FormControlExFactory,
    private _fb: FormBuilder,
    private _service: PriceListService,
    cds: ColumnDefinitionService,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, _service, messageService, navigation, commandDispatcher, handlerResolver);

    this.itemListColumns = cds.create('PriceListItem');
  }

  itemListColumns: ColumnDefinition[];
  private itemListViewColumns: ListViewColumn[] = [];

  get itemListSelectedColumns(): ListViewColumn[] {
    return this.itemListViewColumns.filter(column => column.selected);
  }

  get excelFilter(): { priceListId: string } {
    return { priceListId: this.dataContext.id };
  }

  get excelFileName(): string {
    return this.dataContext.name || 'Prislista';
  }

  onItemListColumnChange(columns: ListViewColumn[]) {
    this.itemListViewColumns = columns;
  }

  protected createModel(): PriceList {
    return new PriceList({ currencyCode: Currencies.SEK, listType: PriceListType.ExternalInvoicing });
  }

  addItem() {
    this.navigation.navigate(['pricelists', this.dataContext.id, 'add-item']);
  }

  currencies = [
    new SelectionItem(Currencies.SEK, Currencies.SEK),
    new SelectionItem(Currencies.EUR, Currencies.EUR),
    new SelectionItem(Currencies.DKK, Currencies.DKK),
  ];

  listTypes = [
    new SelectionItem('PRICELIST.PRICELIST_TYPE_INVOICING', PriceListType.ExternalInvoicing),
    new SelectionItem('PRICELIST.PRICELIST_TYPE_REPORTING', PriceListType.InternalReporting),
  ];

  itemClicked(e: { context: PriceListItem; event: any }) {
    this.navigation.navigate(['pricelists', this.dataContext.id, 'edit-item', e.context.id], null, e.event.ctrlKey);
  }

  protected getFormGroup(): FormGroup {
    const form = this._fb.group({
      id: this._fcf.createHidden(this.dataContext.id),
      name: this._fcf.createMandatory('PRICELIST.PRICELIST', this.dataContext.name),
      currencyCode: this._fcf.createHidden(this.dataContext.currencyCode),
      listType: this._fcf.createWithOptions('PRICELIST.PRICELIST_TYPE', this.dataContext.listType, { isReadonly: !this.isNew }),
    });

    return form;
  }
}
